<!--
 * @Description: 用户持有银行卡信息操作组件，换卡申请记录 由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-24 14:46:45
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="acctManager" :back-url-query="{ activeIndex: '4-1' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager?activeIndex=4-1' }">
                    银行卡
                </el-breadcrumb-item>
                <el-breadcrumb-item>换卡申请记录</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-change-card-list">
            <div class="header-title">
                换卡申请记录
                <div class="time-select-contain">
                    <date-picker sep-text="-" :date="dateSet" v-on:date-get="dateInterval" />
                    <button class="query-btn" v-on:click.prevent="queryData">查询</button>
                </div>
            </div>
            <el-table :data="dataList" class="tab-list-tit table-list">
                <el-table-column prop="appsheetserialno" label="申请单号" align="center" />
                <el-table-column label="申请更换银行卡" align="center">
                    <template slot-scope="scope">
                        {{
                            $cache.getDict("110080", scope.row.bankcode).substr(-4, 4) +
                            $cache.getDict("110079", scope.row.paychannel).substr(0, 4) +
                            "(" +
                            scope.row.depositcard.substr(-4, 4) +
                            ")"
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="operdate" label="申请日期" align="center">
                    <template slot-scope="scope">{{ $util.fmtDate(scope.row.operdate) }}</template>
                </el-table-column>
                <el-table-column prop="status" label="申请状态" align="center">
                    <template slot-scope="scope">
                        {{ $cache.getDict("120198", scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column prop="businesscode" label="操作" align="center">
                    <span class="change-bank-text">换卡</span>
                </el-table-column>
            </el-table>
        </div>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number($util.getConfig().const.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import datePicker from "@/components/form/datePicker";
import userApi from "@/api/user";

export default {
    name: "AddBank",
    components: { datePicker },
    mixins: [mixin],
    data() {
        return {
            curPage: 1,
            allPage: 0,
            dateSet: {
                type: "2",
                min: "19900101",
                size: "mini",
                text: "开始时间",
                text2: "结束时间"
            },
            dataList: [],
            beginDate: "",
            endDate: ""
        };
    },
    mounted() {
        this.getChangeBankList();
    },
    methods: {
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 获取换卡记录
        async getChangeBankList(val = 1) {
            const res = await userApi.combQueryAppAcctList({
                businesscode: "0A7",
                pageSize: this.$util.getConfig().const.PAGE_SIZE,
                pageNum: val,
                begindate: this.beginDate,
                enddate: this.endDate
            });
            if (res.data) {
                this.allPage = res.data.total;
                this.dataList = res.data.data ? res.data.data : [];
            }
        },
        dataReset(val) {
            this.getChangeBankList(val);
        },
        queryData() {
            if (
                (this.beginDate != "" && this.endDate == "") ||
                (this.beginDate == "" && this.endDate != "")
            ) {
                this.$alert("请输入完整的日期范围", "日期提示");
                return false;
            }
            this.getChangeBankList();
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-change-card-list {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-bottom: 52px;
    .header-title {
        width: 1160px;
        height: 60px;
        margin-left: 20px;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .time-select-contain {
            display: flex;
            :deep(.el-input) {
                width: 160px !important;
                .el-input__inner {
                    height: 40px;
                    font-size: 16px;
                    font-weight: normal;
                    color: #999999;
                }
            }
        }
        .query-btn {
            width: 90px;
            height: 40px;
            line-height: 40px;
            border-radius: 2px;
            background: var(--color-primary);
            text-align: center;
            cursor: pointer;
            border: none;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
        }
    }
    .table-list {
        width: 1160px;
        margin: auto;
        margin-top: 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
    }
    .change-bank-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: var(--color-primary);
    }
    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
}
</style>
